const InsufficientPermission = () => {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h2>Insufficient Permission</h2>
        <p>You do not have the required permission to access this page.</p>
      </div>
    );
  };
  
  export default InsufficientPermission;